import { render, staticRenderFns } from "./birthday.view.vue?vue&type=template&id=5cd066a5&scoped=true&"
import script from "./birthday.view.vue?vue&type=script&lang=ts&"
export * from "./birthday.view.vue?vue&type=script&lang=ts&"
import style0 from "./birthday.view.vue?vue&type=style&index=0&id=5cd066a5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd066a5",
  null
  
)

export default component.exports